import styles from "./Player-main-title.module.css"
import cs from "clsx"
import Flag from "react-flagkit"
import wifi from "../../../assets/images/wifi.svg"
import noWifi from "../../../assets/images/no_wifi.svg"
import { Player } from "../lib/player"
interface Props {
  className?: string
  player: Player | null
}

export function PlayerMainTitle({ className, player }: Props) {
  return (
    <div className={styles.root + " " + cs(styles.bg, className)}>
      <div className={styles.column + " " + styles.column_10}>
        {player?.countryCode && <Flag className={styles.country} country={player?.countryCode?.toUpperCase()} />}{" "}
      </div>
      <div className={styles.column + " " + styles.column_70}>
        <div>{player?.subscriptionName && <span className={styles.siteName}>{player?.subscriptionName}</span>}</div>
        <div>
          {" "}
          {player?.displayName && (
            <span className={styles.font}>
              {player?.productName} ({player?.displayName}){" "}
            </span>
          )}
        </div>
      </div>
      <div className={styles.column + " " + styles.column_20}>
        {player?.online === true && <img src={wifi} className={styles.statusWifi} alt="wifi" />}
        {player?.online === false && <img src={noWifi} className={styles.statusWifi} alt="noWifi" />}
      </div>
    </div>
  )
}
